// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { IMPDPanel, MPDPanelStack } from "src/mpd-library";

import { IProps } from "@blueprintjs/core";

import { IToolBarProps, ToolBar } from 'src/components';

import "./styles.css";

export interface IPanelStackProps extends IToolBarProps, IProps {
  currentPanelStack: Array<IMPDPanel>;
  routeProps: any;
  transitionDuration?: number;
  panelStackUpdated?(currentPanelStack: Array<IMPDPanel>): void;
}

interface IPanelStackState {
  currentPanelStack: Array<IMPDPanel>;
  currentPanel?: IMPDPanel;
}

export class PanelStack extends React.PureComponent<
  IPanelStackProps,
  IPanelStackState
> {
  constructor(props: IPanelStackProps) {
    super(props);

    this.addToPanelStack = this.addToPanelStack.bind(this);
    this.removeFromPanelStack = this.removeFromPanelStack.bind(this);

    this.state = {
      currentPanelStack: this.props.currentPanelStack
    };
  }

  public componentWillReceiveProps({ currentPanelStack }: IPanelStackProps) {
    if (currentPanelStack) {
      this.setState({ currentPanel: currentPanelStack[0], currentPanelStack });
    }
  }

  public render() {
    const { className, transitionDuration } = this.props;
    const { currentPanelStack, currentPanel } = this.state;
    const classes = classNames(className);

    let topBarProps;
    let bottomBarProps;

    if (currentPanel) {
      topBarProps = currentPanel.props.topBarProps;
      bottomBarProps = currentPanel.props.bottomBarProps;
    }

    console.log(this.props, "the props");

    return (
      <div className={classNames(classes)}>
        <ToolBar {...topBarProps} />
        {currentPanelStack && (
          <MPDPanelStack
            className="panel-stack"
            onOpen={this.addToPanelStack}
            onClose={this.removeFromPanelStack}
            panelStack={currentPanelStack}
            transitionDuration={transitionDuration}
          />
        )}
        <ToolBar {...bottomBarProps} />
      </div>
    );
  }

  private addToPanelStack(newPanel: IMPDPanel) {
    const { panelStackUpdated } = this.props;
    this.setState({
      currentPanelStack: [newPanel, ...this.state.currentPanelStack]
    });

    if (panelStackUpdated) {
      panelStackUpdated(this.state.currentPanelStack);
    }
  }
  private removeFromPanelStack() {
    const { panelStackUpdated } = this.props;

    this.setState({ currentPanelStack: this.state.currentPanelStack.slice(1) });

    if (panelStackUpdated) {
      panelStackUpdated(this.state.currentPanelStack);
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/panel-stack/panel-stack.tsx